module.exports = __webpack_public_path__ + "img/8.de6ac85b.jpg";